// import EmployeeSurveyForm from "./EmployeeSurveyForm";
import HospitalPolicySurveyForm from "./HospitalPolicySurveyForm";

function App(){
  return(
    <>
    {/* <EmployeeSurveyForm/> */}
    <HospitalPolicySurveyForm/>
    </>
  )  
}
export default App;